import type { SKAdNetworkState } from './SKAdNetwork.types';

export const INIT_STATE: SKAdNetworkState = {
  availableCampaignsForSANAdPartners: undefined,
  isLoadingAvailableCampaignsForSANAdPartners: true,
  updatingAdPartnersForSKANAgencyPermissions: false,
  adPartnersForSKAN: [],
};

export const UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_LOADING =
  'UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_LOADING' as const;

export const UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_SUCCESS =
  'UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_SUCCESS' as const;

export const UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_ERROR =
  'UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_ERROR' as const;
